/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { NotificationMarkAllAsReadResponse } from '../types/NotificationMarkAllAsRead'

/**
 * POST /notifications/read-all
 * @see backend/nexus/modules/Campaign/Http/Controllers/NotificationController.php NotificationController::markAllAsRead
 */
export async function notificationMarkAllAsRead(
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<NotificationMarkAllAsReadResponse>> {
	return axiosInstance.post('/notifications/read-all', undefined, config)
}
